import {
  base_colorContentBorder,
  grey100,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const tableCard = css`
  display: flex;
  flex-direction: column;
`

export const toolbar = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing(3)};
  padding: ${spacing(4)} ${spacing(5)};
  border-bottom: 1px solid ${base_colorContentBorder};
`

export const search = css`
  flex: 1;
`

/*
  The MaskedCardNumber component handles the **** / digit / SR phrase
  triplet; this style just sets typography on its wrapper. The trailing
  space inside the **** literal provides separation, so no gap is
  needed.
*/
export const cardNumber = css`
  font-family: ${font_family_weight_regular};
  ${font_md};
  color: ${text_colorTextPrimary};
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.04em;
  white-space: nowrap;
`

export const actionTrigger = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  color: ${text_colorTextSecondary};

  &:hover {
    background-color: ${grey100};
  }

  &:focus-visible {
    outline: 2px solid ${text_colorTextPrimary};
    outline-offset: 2px;
  }
`

export const actionMenu = css`
  position: absolute;
  top: calc(100% - ${spacing(2)});
  right: ${spacing(4)};
  z-index: 1;
  display: flex;
  flex-direction: column;
  min-width: 160px;
  padding: ${spacing(1)} 0;
  background-color: white;
  border: 1px solid ${base_colorContentBorder};
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
`

export const actionMenuItem = css`
  appearance: none;
  background: transparent;
  border: none;
  text-align: left;
  padding: ${spacing(2)} ${spacing(3)};
  font-family: ${font_family_weight_regular};
  ${font_md};
  color: ${text_colorTextPrimary};
  cursor: pointer;

  &:hover,
  &:focus-visible {
    background-color: ${grey100};
  }
`

export const gridWrap = css`
  width: 100%;
`

export const overlay = css`
  ${font_md};
  color: ${text_colorTextSecondary};
  text-align: center;
  padding: ${spacing(8)} ${spacing(4)};
`

export const truncationNotice = css`
  ${font_sm};
  color: ${text_colorTextSecondary};
  padding: ${spacing(2)} ${spacing(5)};
  border-bottom: 1px solid ${base_colorContentBorder};
`
